(function($) {
  $('.play').click( function() {
    $('video').get(0).play();
    $('.play').hide();
  });

  $('video').click(function(){
    this[this.paused ? 'play' : 'pause']();
  });

})(jQuery);
